import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import { NgModel } from '@angular/forms';
import { NgForm } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { MatSelectModule } from '@angular/material';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AppComponent } from './app.component';
import { DesktopComponent } from './desktop/desktop.component';
import { AlertComponent } from './alert/alert.component';
import { ToolsComponent } from './tools/tools.component';
import { FlexLayoutModule } from '@angular/flex-layout';

import { GlobalsService } from './globals.service';
import { MobileComponent } from './mobile/mobile.component';
import { HelpComponent } from './help/help.component';

const appRoutes: Routes = [
  { path: 'desktop', component: DesktopComponent },
  { path: 'mobile', component: MobileComponent },
  { path: '',   redirectTo: '/desktop', pathMatch: 'full'}, // Default to home
  // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    DesktopComponent,
    AlertComponent,
    ToolsComponent,
    MobileComponent,
    HelpComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),
    BrowserAnimationsModule,
    FormsModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatToolbarModule,
    FlexLayoutModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTabsModule,
    MatDialogModule,
    MatTooltipModule,
  ],
  providers: [
    GlobalsService,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    HelpComponent,
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/app.module.ts